import api from "@/services/Api";

export default {
  async listProperties({}, params) {
    try {
      const { data } = await api.get("/fazendas", { params });
      return data;
    } catch (e) {
      return false;
    }
  },

  async getProperty({}, id) {
    try {
      const { data } = await api.get("/fazendas/" + id);
      return data;
    } catch (e) {
      return false;
    }
  },

  async getLinkAuth({}, id) {
    try {
      const { data } = await api.get("/fazendas/" + id + "/link");
      return data;
    } catch (e) {
      return false;
    }
  },

  async insertProperty({}, form) {
    try {
      const { data } = await api.post("/fazendas", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async updateProperty({}, form) {
    try {
      const { data } = await api.post("/fazendas/" + form.get("id"), form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async destroyProperty({}, id) {
    try {
      const { data } = await api.delete("/fazendas/" + id);
      return data;
    } catch (e) {
      return false;
    }
  },

  async pinProperty({}, id) {
    try {
      const { data } = await api.post("/fazendas/" + id + "/pin");
      return data;
    } catch (e) {
      return false;
    }
  },

  async destroyFiles({}, params) {
    try {
      const type = params.type;
      const ids = params.ids;

      if (!type || !ids || ids.length < 1) return false;

      const { data } = await api.delete("/files", {
        data: { type, ids },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async sendTempKMZ({}, form) {
    try {
      const { data } = await api.post("/temp_kmz", form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    } catch (e) {
      return false;
    }
  },

  async getFromLocation({}, params) {
    try {
      const { data } = await api.get(`/fazendas/search/fromLocation`, {
        params,
      });

      return data;
    } catch (e) {
      return false;
    }
  },

  async getFile({}, params) {
    try {
      const { data } = await api.get(params.path, {
        params: { download: "sim" },
      });
      return data;
    } catch (e) {
      return null;
    }
  },

  async getFile64({}, params) {
    try {
      const { data } = await api.get(`/fazendas/file64/download`, {
        params: { download: "sim" },
      });
      return data;
    } catch (e) {
      return null;
    }
  },

  async createLink({}, params) {
    try {
      const { data } = await api.post(`/fazendas/token/createLink`, params);
      return data;
    } catch (e) {
      return null;
    }
  },

  async deleteLink({}, id) {
    try {
      const { data } = await api.delete(`/fazendas/links/delete/` + id);
      return data;
    } catch (e) {
      return false;
    }
  },

  async getLink({}, token) {
    try {
      const { data } = await api.get(`/getLink/${token}`);
      return data;
    } catch (e) {
      return null;
    }
  },

  async listLinks({}, params) {
    try {
      const { data } = await api.get("/fazendas/links/index", { params });
      return data;
    } catch (e) {
      return false;
    }
  },
};
